import axios from "./axios-handler.service";
const BASE_URL = "/api/Faqs";

export interface Faq {
  idFaq: number;
  pergunta: string;
  descricao: string;
  resposta: string;
  quantidadeVisita: number;
  quantidadeUtil: number;
  quantidadeInutil: number;
  ativo: boolean;
  topicosFaq: TopicoFaq;
}

export interface TopicoFaq {
  idTopico: number;
  idFaq: number;
  ordem: number;
  faq: any;
}

export interface FaqNovo {
  idFaq?: number | null;
  pergunta: string;
  descricao: string;
  resposta: string;
  ativo: boolean;
  topicos: number[];
}

export interface FiltroFaqs {
  topico: number | null;
  txtPesquisa: string;
  ativo: boolean | null;
  offset: number;
  limit: number;
  order?: string;
}

export class FaqsService {
  static async Lista(filtro: FiltroFaqs): Promise<any> {
    const { topico, txtPesquisa, ativo, offset, limit, order } = filtro;
    const response = await axios.get<any>(BASE_URL + "/Lista", {
      params: {
        idTopico: topico,
        txtPesquisa,
        ativo,
        offset,
        limit,
        order
      },
    });
    return response.data;
  }

  static async ListaAlterarOrdem(
    idTopico: number | null
  ): Promise<Faq[]> {
    const response = await axios.get<any>(BASE_URL + "/ListaAlterarOrdem", {
      params: {
        idTopico,
      },
    });
    return response.data;
  }

  static async AlterarOrdem(idTopico: number, idFaq: number[]): Promise<void> {
    await axios.post(BASE_URL + "/AlterarOrdem",
      idFaq,
      {
        params: {
          idTopico,
        }
      });
  }

  static async Excluir(idFaq: number): Promise<void> {
    const response = await axios.post(`${BASE_URL}/Excluir`, { idFaq });
    return response.data;
  }

  static async SiteUrl(): Promise<string> {
    const response = await axios.get<string>(BASE_URL + "/SiteUrl");
    return response.data;
  }

  static async Manter(faq: FaqNovo): Promise<void> {
    await axios.post(BASE_URL + "/Manter", faq)
  }

  static async Obter(idFaq: number): Promise<FaqNovo>{
    const response = await axios.get(BASE_URL + "/Manter", { params: { idFaq } });
    return response.data;
  }
}